module.exports = __webpack_public_path__ + "static/img/img-advantage3.0b5f1f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-advantage3.svg
// module id = 5+YQ
// module chunks = 0